/**
 * @file パスポート登録
 *
 */
'use strict';

import Modal from '../../Libs/bootstrap/modal';

/**
 * @classname RegistPassport
 * @classdesc パスポート登録
 */
export default class RegistPassport {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('RegistPassport.constructor');
		this._$e = $e;
		this._controller = controller;
		$e.on('click', () => this.onClick());
	};

	/**
	 * クリックのコールバック
	 *
	 * @memberof SetComplete
	 * @return {undefined}
	 */
	onClick() {
		console.log('RegistPassport.onClick');
		localStorage.removeItem('passport');
		localStorage.removeItem('passport_list');
		this._controller.displayPassportInfo();
		$('.block--page1').hide();
		$('.block--page2').show();
	};
}
